onInteractive(function() {
	// The navigation bar shrinks for good after the first real scroll, so the header does not jump back and forth.
	var onScroll = function() {
		if (window.scrollY > 160) {
			document.body.classList.add('has-scrolled');
			window.removeEventListener('scroll', onScroll);
		}
	};
	window.addEventListener('scroll', onScroll, { passive: true });
	onScroll();

	// The quote form stays folded away until a visitor asks for it, except on the home page.
	var offerte = document.getElementById('offerte-aanvragen');
	if (offerte) {
		var openOfferte = function(scroll) {
			offerte.classList.add('active');
			if (scroll) {
				offerte.scrollIntoView({ behavior: 'smooth' });
			}
		};
		if (
			document.documentElement.getAttribute('data-home') === 'true'
			|| window.location.hash === '#offerte-aanvragen'
			|| offerte.querySelector('.alert:not([hidden])')
		) {
			openOfferte(window.location.hash === '#offerte-aanvragen');
		}

		// Links to the form are rewritten to a page url plus hash, so match on the hash alone.
		document.addEventListener('click', function(event) {
			var link = event.target.closest('a[href*="#offerte-aanvragen"]');
			if (!link) {
				return;
			}
			event.preventDefault();
			var collapse = document.getElementById('navbar-supported-content');
			if (collapse && collapse.classList.contains('show')) {
				var toggler = document.querySelector('[data-target="#navbar-supported-content"]');
				if (toggler) {
					toggler.click();
				}
			}
			openOfferte(true);
		});
	}

	// The project slider on the home page gets a clickable list of its titles next to it.
	var feed = document.querySelector('.home-projects-feed');
	var list = document.querySelector('.home-projects-list');
	if (feed && list && window.jQuery) {
		var items = feed.querySelectorAll('.carousel-item');
		var titles = document.createElement('ul');
		titles.className = 'home-projects-titles';
		items.forEach(function(item, index) {
			var title = item.querySelector('.title');
			var li = document.createElement('li');
			var button = document.createElement('button');
			button.type = 'button';
			button.textContent = title ? title.textContent.trim() : '';
			if (item.classList.contains('active')) {
				button.classList.add('active');
			}
			button.addEventListener('click', function() {
				window.jQuery(feed).carousel(index);
			});
			li.appendChild(button);
			titles.appendChild(li);
		});
		list.appendChild(titles);
		window.jQuery(feed).on('slide.bs.carousel', function(event) {
			titles.querySelectorAll('button').forEach(function(button, index) {
				button.classList.toggle('active', index === event.to);
			});
		});
	}
});
